import { ThunkResult } from '../../store'
import { replaceResult, replaceResultData } from './CustomLabels.slice'
import customLabelApi from '../../apis/customLabel.api'
import customLabelService from '../../services/customLabel.service'
import storageService from '../../services/storage.service'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().items
    var params = { page, limit, search }

    var searchStr = storageService.get("customLabelSearch");
    var pageStr = storageService.get("customLabelPage");
    var limitStr = storageService.get("customLabelLimit");

    if(pageStr != "" && pageStr != null && pageStr != undefined)
      params.page = pageStr;

    if(searchStr != "" && searchStr != null && searchStr != undefined)
      params.search = searchStr;

    if(limitStr != "" && limitStr != null && limitStr != undefined)
      params.limit = limitStr;

    customLabelApi.paginate(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deleteCustomLabel (id: number): ThunkResult<void> {
  return (dispatch, getState) => {
    customLabelApi.delete(id, customLabel => {
      if (!customLabel) return
      const { result } = getState().customLabels
      const data = customLabelService.delete(result.data, id)
      dispatch(replaceResultData(data))
    })
  }
}
